import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决重复跳转路由
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      name: 'Main',
      component: resolve => require(['@/components/Main.vue'], resolve),
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: resolve => require(['@/components/Home.vue'], resolve),
        },
        {// 用户协议
          path: '/userAgree',
          name: 'UserAgree',
          component: () => import('@/components/agreement/Agree.vue'),
        },
        {// 隐私策略
          path: '/privacyContent',
          name: 'PrivacyContent',
          component: () => import('@/components/agreement/Privacy.vue'),
        },
        {//体验页面
          path: '/dataSearchMain',
          name: 'DataSearchMain',
          component: () => import('@/components/search/DataSearchMain.vue'),
          meta: {
            requireAuth: true,  // 该路由项需要权限校验
          },
        },
        {// 关于版本历史
          path:'/aboutVersionHistory',
          name:'AboutVersionHistory',
          component: () => import('@/components/aboutVersion/versionIndex.vue'),
        }
      ]
    },
    // {//体验页面
    //   path: '/dataSearchMain',
    //   name: 'DataSearchMain',
    //   component: () => import('@/components/search/DataSearchMain.vue'),
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js